module.exports = __webpack_public_path__ + "static/media/together-illustration.412e6d78.jpeg";